import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerTextGraphic } from "@visactor/vrender-core/register/graphic";

import { textModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindTextCanvasPickerContribution } from "../picker/contributions/canvas-picker/text-module";

import { bindTextMathPickerContribution } from "../picker/contributions/math-picker/text-module";

function _registerText() {
    if (_registerText.__loaded) return;
    _registerText.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerTextGraphic(), textModule({
        bind: legacyContext.bind
    }), browser ? bindTextCanvasPickerContribution(legacyContext) : bindTextMathPickerContribution(legacyContext);
}

_registerText.__loaded = !1;

export const registerText = _registerText;
//# sourceMappingURL=register-text.js.map